import normalizer from '@cordel/helpers/form/schema';

import {
  USED,
  USED_LICENSING,
} from './sections';

import {
  KM,
  PLATE,
  RENAVAM,
  CHASSIS,
  COLOR,
  LICENSING_UF,
  LICENSING_CITY,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [USED]: {
        title: 'Estamos quase lá!',
        subtitle: 'Para continuar, precisamos de algumas informações adicionais:',
        hierarchy: 'h3',
      },
    },

    fields: {
      [KM]: {
        section: USED,
        label: 'Quilometragem (km)',
        placeholder: 'Quilômetros rodados',
        validations: [{
          type: 'blank',
        }, {
          type: 'notANumber',
        }],
        size: 6,
        visible: false,
      },
      [PLATE]: {
        section: USED,
        label: 'Placa',
        placeholder: 'Ex: ABC1E23 (maiúsculo)',
        validations: [{
          type: 'blank',
        }, {
          type: 'plate',
        }],
        size: 6,
        visible: false,
      },
      [RENAVAM]: {
        section: USED,
        label: 'Renavam',
        placeholder: 'Número do Renavam',
        validations: [{
          type: 'blank',
        }, {
          type: 'renavam',
        }],
        size: 6,
        visible: false,
      },
      [CHASSIS]: {
        section: USED,
        label: 'Chassi',
        placeholder: 'Número do Chassi',
        validations: [{
          type: 'blank',
        }, {
          type: 'chassis',
        }],
        size: 6,
        visible: false,
      },
      [COLOR]: {
        section: USED,
        type: 'select',
        label: 'Cor',
        placeholder: 'Cor do veículo',
        validations: [{
          type: 'blank',
        }],
        size: 12,
        visible: false,
      },
      [LICENSING_UF]: {
        section: USED,
        subsection: USED_LICENSING,
        type: 'select',
        label: 'Estado de licenciamento',
        placeholder: 'Escolha um estado',
        validations: [{
          type: 'blank',
        }],
        visible: false,
        size: 6,
        disabled: true,
      },
      [LICENSING_CITY]: {
        section: USED,
        subsection: USED_LICENSING,
        label: 'Cidade de licenciamento',
        placeholder: 'Digite a cidade',
        validations: [{
          type: 'blank',
        }],
        visible: false,
        size: 6,
      },
    },
  });
}
